import { Box, Divider, Typography } from '@vp/swan';
import React from 'react';
import { getFormattedTime } from '../../utils/miaw/common';
import './ConversationEvent.styles.scss';

export interface IConversationEventProps {
  eventDetails: string;
  timeStamp: number;
  width?: string;
  paddingX?: '1' | '2' | '3' | '4' | '5' | '6' | '7';
  hideTimestamp?: boolean;
}

const ConversationEvent: React.FC<IConversationEventProps> = ({ eventDetails, timeStamp, paddingX, width, hideTimestamp }) => {
  return (
    <>
      <Box paddingY={6} style={width ? { width } : {}} paddingX={paddingX} compactMode>
        <Divider marginBottom={2} />
        <Typography fontSize="small" textColor="subtle" textAlign="center">
          {eventDetails}
          {!hideTimestamp && (
            <>
              {' · '}
              {getFormattedTime(timeStamp)}
            </>
          )}
        </Typography>
      </Box>
    </>
  );
};

export default ConversationEvent;
